import { render, staticRenderFns } from "./ClientAccountActions.vue?vue&type=template&id=2c0c786f&scoped=true&"
import script from "./ClientAccountActions.vue?vue&type=script&lang=js&"
export * from "./ClientAccountActions.vue?vue&type=script&lang=js&"
import style0 from "./ClientAccountActions.vue?vue&type=style&index=0&id=2c0c786f&prod&lang=scss&"
import style1 from "./ClientAccountActions.vue?vue&type=style&index=1&id=2c0c786f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c786f",
  null
  
)

export default component.exports